<template>
  <div v-if="record">
    <nav class="border-b border-gray-300 px-2 md:px-0 py-2">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'broadcasts'}">Broadcasts</router-link>
            <span class="mx-2">/</span>
            <span>{{ record.title || 'Group' }}</span>
          </div>
          <div class="text-xl">
            {{ record.title }}
          </div>
        </div>
        <div class="">
          <div class="inline-block relative float-right" v-if="path=== 'schedules'">
            <button v-if="$store.getters.can('create_groups')"
                    style="color: white !important;" @click="showModals({modal: 'schedule',id:id})"
                    class="bg-teal-500 text-white hover:bg-teal-700 py-2 px-4 rounded-sm inline-flex items-center">
              Schedule
            </button>
          </div>
        </div>
      </div>
    </nav>
    <div class="py-4 md:px-0 px-2">
      <div class="md:flex block">
        <div class="w-full rounded-lg  overflow-hidden  md:max-w-xs mb-3">
          <div class=" bg-white rounded-lg border shadow-sm">
            <div class="text-center px-3 pb-6 pt-2">
              <h3 class="text-black text-sm bold font-sans">{{ record.title || '' }}</h3>
              <p class="mt-2 font-sans font-light text-grey-dark">{{ record.description }}</p>
            </div>

            <ul class="mt-2 flex flex-wrap md:block">
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'broadcast', params: {id: id, path:'messages'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="message-circle" size="16" class="mr-4"></feather>
                  Sent Messages
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2">
                <router-link :to="{name:'broadcast', params: {id: id, path:'email'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="mail" size="16" class="mr-4"></feather>
                  Email
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
                <router-link :to="{name:'broadcast', params: {id: id, path:'sms'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="message-square" size="16" class="mr-4"></feather>
                  SMS
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
                <router-link :to="{name:'broadcast', params: {id: id, path:'schedules'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="clock" size="16" class="mr-4"></feather>
                  Schedules
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
                <router-link :to="{name:'broadcast', params: {id: id, path:'settings'}}"
                             class="block items-center flex lg:mt-0 px-3 h-8 hover:text-teal-700">
                  <feather type="settings" size="16" class="mr-4"></feather>
                  Settings
                </router-link>
              </li>
              <li class="border-l-4 border-transparent hover:border-teal-700 my-2 ">
                <div @click="deleteRecord" v-if="$store.getters.can('delete_groups')"
                     class="block items-center flex lg:mt-0 px-3 h-8 hover:text-red-700 text-red-500">
                  <feather type="delete" size="16" class="mr-4"></feather>
                  Delete
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="w-full mt-3 md:mt-0 md:mx-4">
          <ComposeMail :id="id" v-if="path === 'email'"/>
          <UpdateSmsComponent :id="id" v-else-if="path === 'sms'"/>
          <BroadcastSchedules :breadcrumb="false" :id="id" v-else-if="path === 'schedules'"/>
          <NewBroadcastMessageComponent :breadcrumb="false" :id="id" v-else/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";
import ComposeMail from "@/modules/Broadcasts/ComposeMail";
import UpdateSmsComponent from "@/modules/Broadcasts/UpdateSmsComponent";
import NewBroadcastMessageComponent from "@/modules/Broadcasts/NewBroadcastMessageComponent";
import BroadcastSchedules from "@/modules/Broadcasts/BroadcastSchedules";

export default {
  name: "BroadcastComponent",
  components: {BroadcastSchedules, NewBroadcastMessageComponent, UpdateSmsComponent, ComposeMail},
  data() {
    return {
      record: Object,
      orgId: this.$store.getters.orgId,
    }
  },
  props: {
    id: String,
    path: String,
  },
  mounted() {
    this.getRecord();
  },
  methods: {
    showModals(data) {
      this.$root.$emit("show_modal", data);
    },
    getRecord() {
      this.loading = true
      GraphQl.sendRequest('{broadcast(id:"' + this.id + '"){title description id}}')
          .then(response => {
            this.record = response.broadcast;
          })
    },

    deleteRecord() {
      let delConfirm = confirm("Are you sure you want to delete this broadcast?")
      if (delConfirm)
        GraphQl.sendRequest('mutation{deleteBroadcast(id: "' + this.id + '"){code message}}')
            .then(response => {
              this.$root.$emit(response.deleteBroadcast.code === 200 ? 'alert_success' : 'alert_error', [response.deleteBroadcast.message]);
              if (response.deleteBroadcast.code === 200)
                this.$router.push({name: 'broadcasts'})
            })
    }
  }
}
</script>

<style scoped>

</style>